import { DnsSetupPage, LazyPage } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function DnsSetupRoute() {
  return (
    <LazyPage>
      <DnsSetupPage />
    </LazyPage>
  );
}

export const Route = createFileRoute('/cli/dns-setup')({
  component: DnsSetupRoute,
});
